import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { UntypedFormGroup, Validators } from '@angular/forms';

import { Store } from '@ngrx/store';
import { of } from 'rxjs';

import { PackagingUnitDetailedResponse } from '@app/api/models';
import {
  ContainerStandaloneSubtype,
  containerStandaloneSubtypes,
} from '@containers/interfaces/container.interface';
import { Unit } from '@products/interfaces/unit';
import {
  CollectionSubtype,
  StandaloneSubtype,
  collectionSubtypes,
  standaloneSubtypes,
} from '@shared/enums/packaging-subtype';

import {
  ProductPackagingUnitActions,
  ProductPackagingUnitSelectors,
} from './store/product-packaging-unit.slice';

@Component({
  selector: 'app-packaging-unit',
  templateUrl: './packaging-unit.component.html',
  styleUrls: ['./packaging-unit.component.scss'],
})
export class PackagingUnitComponent implements OnChanges {
  @Input() form!: UntypedFormGroup;
  @Input() TITLE = '';
  @Input() readOnly = false;

  get isCollection(): boolean {
    return this.form.value.mainType === 'COLLECTION';
  }

  subtypes: (
    | ContainerStandaloneSubtype
    | StandaloneSubtype
    | CollectionSubtype
  )[] = [];
  standalonePackagingUnits$ = this.store.select(
    ProductPackagingUnitSelectors.selectStandalonePackagingUnits
  );
  collectionPackagingUnits$ = this.store.select(
    ProductPackagingUnitSelectors.selectCollectionPackagingUnits
  );
  units = Unit;

  originalValue?: PackagingUnitDetailedResponse = undefined;

  constructor(private store: Store) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['form'] && this.form) {
      this.originalValue = this.form.value;
      if (this.isCollection) {
        this.subtypes = [...collectionSubtypes];
      } else {
        if (this.form.value.withDepositFee) {
          this.subtypes = [...containerStandaloneSubtypes];
        } else {
          this.subtypes = [...standaloneSubtypes];
        }
      }
      if (this.form.value.packingMethodSubType && !this.readOnly) {
        this.onSubtypeChange(this.form.value.packingMethodSubType);
      }

      if (this.readOnly) {
        this.standalonePackagingUnits$ = of([
          { id: '', name: this.form.controls['refName']?.value ?? '-' },
        ]);
        this.collectionPackagingUnits$ = of([
          { id: '', name: this.form.controls['refName']?.value ?? '-' },
        ]);
        this.form.controls['refId'].patchValue('');
      }
    }
  }

  changeDepositFee(showContainerTypes: boolean) {
    if (this.originalValue?.withDepositFee !== showContainerTypes) {
      this.form.controls['packingMethodSubType'].reset();
      this.form.controls['refId'].reset();
      if (showContainerTypes) {
        if (!this.isCollection) {
          this.subtypes = [...containerStandaloneSubtypes];
        }
        this.form.controls['refId'].setValidators(Validators.required);
      } else {
        if (!this.isCollection) {
          this.subtypes = [...standaloneSubtypes];
        }
        this.form.controls['refId'].clearValidators();
      }
    }
  }

  onSubtypeChange(event: string) {
    if (!event) return;
    if (this.isCollection) {
      this.store.dispatch(
        ProductPackagingUnitActions.loadCollectionPackagingUnits.trigger({
          withDepositFee: this.form.value.withDepositFee,
          packingMethodSubType: event,
        })
      );
    } else {
      this.store.dispatch(
        ProductPackagingUnitActions.loadStandalonePackagingUnits.trigger({
          withDepositFee: this.form.value.withDepositFee,
          packingMethodSubType: event,
        })
      );
    }

    if (this.originalValue?.packingMethodSubType !== event) {
      this.form.controls['refId'].setValue('');
      this.originalValue = {
        ...this.originalValue,
        packingMethodSubType: event,
      } as PackagingUnitDetailedResponse;
    }
  }
}
